import * as Actions from 'app/store/actions/session/session.actions';

const initialState = {
 loadingLogoutSession: false
}

const sessionReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.GET_SESSION_HISTORY: {
			console.log("GET_SESSION_HISTORY", action)
			return {
				...state,
				session: action.data.sessionData
			};
		}
		case Actions.LOGOUT_ALL_SESSION: {
			return {
				...state,
				loadingLogoutSession: false
			};
		}
		case Actions.LOADING_SESSION: {
			return {
				...state,
				loadingLogoutSession: false
			};
		}
		default:
			return state;
	}
};

export default sessionReducer;
